import { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What digital marketing services does Ashvya Digital Media offer in Ghaziabad?",
      answer: "Ashvya Digital Media offers comprehensive digital marketing services including Social Media Marketing (Facebook, Instagram, LinkedIn), Google Ads management, Meta Ads campaigns, lead generation, creative reels production, content marketing, website development, SEO services, and business development consulting across Ghaziabad, Noida, and entire Delhi NCR region.",
      keywords: ["digital marketing services", "Ghaziabad", "social media marketing", "Google Ads"]
    },
    {
      question: "How much does digital marketing cost in Delhi NCR?",
      answer: "Digital marketing costs vary based on your business needs and goals. At Ashvya Digital Media, we offer customized packages starting from ₹15,000/month for small businesses to comprehensive enterprise solutions. Our services deliver an average ROI of 300%, making it a highly cost-effective investment. Contact us at 9068922387 for a free consultation and custom quote.",
      keywords: ["digital marketing cost", "pricing", "ROI", "Delhi NCR"]
    },
    {
      question: "What is the average ROI from digital marketing campaigns?",
      answer: "Our clients typically experience a 300% average ROI from our digital marketing campaigns. For real estate clients in Noida, we've generated 800+ qualified leads with cost-per-lead as low as ₹85. Healthcare providers have seen 60% increase in patient appointments. Results vary by industry, budget, and campaign objectives.",
      keywords: ["ROI", "digital marketing results", "lead generation", "campaign performance"]
    },
    {
      question: "How long does it take to see results from digital marketing?",
      answer: "Timeline varies by service: Paid ads (Google Ads, Meta Ads) show results within 2-4 weeks. Social media growth takes 2-3 months for significant traction. SEO results appear in 3-6 months. Lead generation campaigns start delivering within the first month. We provide detailed weekly reports to track your progress.",
      keywords: ["digital marketing timeline", "results", "campaign duration"]
    },
    {
      question: "Why should I choose Ashvya Digital Media over other agencies?",
      answer: "Ashvya Digital Media stands out with: 1) Local expertise in Modinagar, Ghaziabad, and Delhi NCR markets, 2) Proven track record with 100+ happy clients, 3) 300% average ROI, 4) Industry-specific experience (real estate, healthcare, e-commerce), 5) Transparent reporting, 6) Dedicated account manager, 7) Rapid growth strategies that make brands go viral.",
      keywords: ["best digital marketing agency", "Ghaziabad", "Modinagar", "Delhi NCR"]
    },
    {
      question: "What is the difference between Google Ads and Facebook Ads?",
      answer: "Google Ads targets users actively searching for products/services (high intent), ideal for immediate conversions. Facebook/Meta Ads target users based on interests and demographics (discovery), perfect for brand awareness and retargeting. We recommend using both for maximum reach and ROI. Our expert team manages integrated campaigns across both platforms.",
      keywords: ["Google Ads vs Facebook Ads", "paid advertising", "Meta Ads"]
    },
    {
      question: "How do you generate leads for real estate businesses?",
      answer: "Our real estate lead generation strategy includes: Hyperlocal Facebook/Instagram ads targeting specific neighborhoods, Google Ads for high-intent keywords, engaging property reels and virtual tours, landing pages with lead capture forms, WhatsApp Business integration for instant responses, and retargeting campaigns. We've generated 500+ monthly leads for real estate clients in Noida with 40% cost reduction.",
      keywords: ["real estate marketing", "lead generation", "Noida", "property marketing"]
    },
    {
      question: "Do you provide social media management services?",
      answer: "Yes! Our comprehensive social media management includes: content strategy and calendar, professional graphics and reels creation, daily posting and scheduling, community management and engagement, influencer collaborations, paid social advertising, monthly analytics and reporting. We manage Facebook, Instagram, LinkedIn, Twitter, and YouTube channels.",
      keywords: ["social media management", "content creation", "Instagram reels", "social media marketing"]
    },
    {
      question: "What makes content go viral on social media?",
      answer: "Viral content requires: Strong hook in first 3 seconds, high-quality visuals and audio, trending sounds and hashtags, clear value proposition (educational, entertaining, or emotional), optimal posting times (6-9 PM), engagement within first hour, and strategic boosting. Our creative team specializes in producing scroll-stopping reels that consistently achieve 50K+ organic views.",
      keywords: ["viral marketing", "social media content", "Instagram reels", "viral campaigns"]
    },
    {
      question: "How can healthcare providers benefit from digital marketing?",
      answer: "Healthcare digital marketing helps: Increase patient appointments by 60%, improve online visibility through local SEO, build trust with patient testimonials and doctor profiles, educate patients through health content, manage online reputation, reach specific demographics with targeted ads. We've successfully helped hospitals and clinics across Ghaziabad grow their patient base ethically and compliantly.",
      keywords: ["healthcare marketing", "hospital marketing", "patient acquisition", "medical marketing"]
    },
    {
      question: "What is local SEO and why does it matter for my business?",
      answer: "Local SEO optimizes your business for 'near me' searches and local Google results. 46% of all Google searches are local, and 76% result in phone calls. We optimize your Google Business Profile, build local citations, manage reviews, create location-specific content, and implement schema markup. This helps you dominate search results in Modinagar, Ghaziabad, Noida, and surrounding areas.",
      keywords: ["local SEO", "Google Business Profile", "local search", "Ghaziabad SEO"]
    },
    {
      question: "How do I measure the success of my digital marketing campaigns?",
      answer: "We track key metrics including: Website traffic and source, Conversion rates and cost per acquisition (CPA), Return on ad spend (ROAS), Lead quality and quantity, Social media engagement and reach, Email open and click rates, Phone calls and form submissions. You receive detailed monthly reports with actionable insights and recommendations.",
      keywords: ["marketing metrics", "campaign tracking", "ROI measurement", "analytics"]
    },
    {
      question: "Can you help with website design and development?",
      answer: "Absolutely! We build conversion-focused websites with: Mobile-responsive design, Fast loading speeds, SEO optimization, User-friendly navigation, Integrated contact forms and chatbots, E-commerce functionality, Content management system (CMS), Secure hosting and maintenance. Our websites are designed to convert visitors into customers with clear calls-to-action and compelling design.",
      keywords: ["website development", "web design", "website building", "responsive website"]
    },
    {
      question: "What industries do you specialize in?",
      answer: "We have proven expertise in: Real Estate (property marketing, lead generation), Healthcare (hospitals, clinics, diagnostic centers), E-commerce (online stores, product marketing), Education (schools, coaching institutes), Hospitality (hotels, restaurants), Professional Services (lawyers, consultants, agencies), Technology (SaaS, IT services), Retail (local businesses, franchises). Each industry gets customized strategies based on unique market dynamics.",
      keywords: ["industry expertise", "specialized marketing", "niche marketing"]
    },
    {
      question: "How often should I post on social media?",
      answer: "Optimal posting frequency: Instagram - 1-2 posts daily + 3-5 stories, Facebook - 1-2 posts daily, LinkedIn - 3-5 posts weekly, Twitter - 3-5 tweets daily, YouTube - 2-4 videos weekly. Quality matters more than quantity. We create content calendars ensuring consistent, engaging posts that align with your brand voice and audience preferences.",
      keywords: ["social media frequency", "posting schedule", "content calendar"]
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-24 md:py-32 bg-white" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-100 rounded-full mb-6">
            <HelpCircle className="w-5 h-5 text-teal-600" />
            <span className="text-sm font-bold uppercase tracking-wider text-teal-600">FAQs</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-slate-600">
            Get answers to common questions about digital marketing services in Ghaziabad and Delhi NCR
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-slate-50 border border-slate-200 rounded-2xl overflow-hidden transition-all duration-300 hover:border-teal-300"
              data-testid={`faq-item-${index}`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left"
                data-testid={`faq-question-${index}`}
              >
                <h3 className="text-lg font-bold text-slate-900 pr-4">{faq.question}</h3>
                {openIndex === index ? (
                  <ChevronUp className="w-6 h-6 text-teal-600 flex-shrink-0" />
                ) : (
                  <ChevronDown className="w-6 h-6 text-slate-400 flex-shrink-0" />
                )}
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-slate-700 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center bg-gradient-to-r from-teal-50 to-cyan-50 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-slate-900 mb-3">Still Have Questions?</h3>
          <p className="text-slate-600 mb-6">
            Our digital marketing experts are here to help you grow your business
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:9068922387"
              className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-3 rounded-full font-bold transition-colors"
            >
              Call: 9068922387
            </a>
            <a
              href="mailto:ashvyadigitalmedia@gmail.com"
              className="bg-white hover:bg-slate-50 text-slate-900 border-2 border-slate-200 px-8 py-3 rounded-full font-bold transition-colors"
            >
              Email Us
            </a>
          </div>
        </div>
      </div>

      {/* Schema markup for FAQs */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>
    </section>
  );
};

export default FAQ;
